import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ButtonModule } from '@teamfoster/sdk/button';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';
import { RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha-2';
import { lastValueFrom } from 'rxjs';
import { AlertComponent } from '../alert/alert.component';
import { LoadingIndicatorComponent } from '../loading-indicator/loading-indicator.component';

@Component({
  selector: 'app-newsletter-form',
  standalone: true,
  imports: [
    ButtonModule,
    DictionaryNgrxModule,
    IconComponent,
    MatInput,
    MatFormField,
    ReactiveFormsModule,
    MatError,
    AlertComponent,
    RecaptchaV3Module,
    LoadingIndicatorComponent,
  ],
  templateUrl: './newsletter-form.component.html',
  styleUrl: './newsletter-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterFormComponent {
  private fb = inject(FormBuilder);
  private http = inject(HttpClient);
  private recaptcha = inject(ReCaptchaV3Service);

  newsletterList = input<number>(34); // optional: ID of the newsletter list to subscribe to

  newsletterForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });

  loading = signal(false);
  triedSubmitting = signal(false);
  submitted = signal(false);
  error = signal('');

  async onSubmit() {
    if (this.newsletterForm.invalid) {
      this.triedSubmitting.set(true);
      this.error.set('Dit is geen geldig e-mailadres');
      return;
    }

    await this.submitSubscription(this.newsletterForm.value.email!, this.newsletterList());
    this.error.set('');
    this.loading.set(false);
    this.submitted.set(true);
    this.triedSubmitting.set(false);
  }

  private async submitSubscription(email: string, list: number) {
    this.loading.set(true);
    try {
      const token = await lastValueFrom(this.recaptcha.execute('NewsletterForm'));
      const result = await lastValueFrom(this.http.post('/api/newsletter/subscribe', { email, groups: [list], token }));
      this.submitted.set(true);
    } catch (error) {
      this.error.set(`${error}`);
      this.submitted.set(false);
    } finally {
      this.loading.set(false);
    }
  }
}
